var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditorAddAudio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#editor_add_audio_svg__clip0_1181_1852)",
    stroke: "#98BDBD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.167 4.667L5 8H1.667v5H5l4.167 3.333V4.667zM15.892 4.608a8.334 8.334 0 010 11.784M12.95 7.55a4.167 4.167 0 010 5.892"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "editor_add_audio_svg__clip0_1181_1852"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(90 9.75 10.25)",
    d: "M0 0h20v20H0z"
  })))));
}
export default SvgEditorAddAudio;